import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/IracingAuth.css";

const ERROR_MESSAGES = {
        missing_code_or_state: "iRacing didn't send back the expected information. Please try signing in again.",
        invalid_or_expired_state: "Your sign-in attempt expired. Please start the iRacing sign-in again.",
        no_cust_id: "We couldn't read your iRacing customer ID. Please make sure your iRacing account is active and try again.",
        user_not_found: "We couldn't find the website account you were trying to link. Please log in and try again.",
        already_linked_to_other_account: "This iRacing account is already linked to a different iRacingData website account.",
        callback_failed: "Something went wrong while completing your iRacing sign-in. Please try again.",
        missing_token: "Your sign-in didn't complete correctly. Please try again.",
};

const IracingAuthError = () => {
        const navigate = useNavigate();
        const params = new URLSearchParams(window.location.search);
        const errorCode = params.get("error") || "";
        const description = params.get("description") || "";

        const friendly = ERROR_MESSAGES[errorCode] || "An unexpected error occurred during iRacing sign-in.";

        return (
                <div className="iracing-auth-page">
                        <div className="iracing-auth-card iracing-auth-error">
                                <h2>iRacing Sign-in Failed</h2>
                                <p className="iracing-auth-error-message">{friendly}</p>
                                {description && <p className="iracing-auth-error-detail">Details: {description}</p>}
                                <button
                                        type="button"
                                        className="iracing-auth-back-btn"
                                        onClick={() => navigate("/login")}
                                >
                                        Back to Login
                                </button>
                        </div>
                </div>
        );
};

export default IracingAuthError;
